import styled, { css } from 'styled-components';

export interface ScContinueWithGoogleConfig {
  dividerGap: 'small' | 'large';
  marginBottom: 'small' | 'large';
  isGoogleAuth?: boolean;
}

const STYLES_CONFIG = {
  dividerGap: { small: '16px', large: '32px' },
  marginBottom: { small: '16px', large: '24px' },
  googleAuth: { marginBottom: '0px' },
} as const;

export const ScContinueWithGoogle = styled.div<ScContinueWithGoogleConfig>`
  display: flex;
  flex-direction: column;
  gap: ${({ dividerGap }) => STYLES_CONFIG.dividerGap[dividerGap]};
  margin-bottom: ${({ marginBottom }) => STYLES_CONFIG.marginBottom[marginBottom]};

  ${({ isGoogleAuth }) =>
    isGoogleAuth &&
    css`
      margin-bottom: ${STYLES_CONFIG.googleAuth.marginBottom};
    `}

  .image {
    margin-right: 8px;
  }

  .text {
    font-size: 16px;
  }
`;
